function t(r, l) {
  for (var a in r)
    if ({}.hasOwnProperty.call(r, a) && (!{}.hasOwnProperty.call(l, a) || r[a] !== l[a]))
      return !1;
  for (var n in l)
    if ({}.hasOwnProperty.call(l, n) && !{}.hasOwnProperty.call(r, n))
      return !1;
  return !0;
}
export {
  t as shallowEqual
};
